import React from "react";
import { Col } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { NumericFormat } from 'react-number-format';

export default function CountCardComponent({ data, formState }) {

	const navigate = useNavigate();


	const handleCardClick = (key) => {
		formState.key = key;
		navigate(`/dashboard-count-list`, { state: formState });

	};
	const floats = [
		{
			key: "total_children_rescued",
			title: "Total Children Rescued",
			digit: data?.total_children_rescued,
			icon: "child_care",
			variant: "lg blue",
		},
		{

			key: "total_slave_born",

			title: "Total Born Slave Rescued",
			digit: data?.total_slave_born,
			icon: "price_check",
			variant: "lg red",
		},
		{
			key: "teenage_count",

			title: "Teenage Children (13-19 age)",
			digit: data?.teenage_count,
			icon: "price_check",
			variant: "lg blue",
		},
		{
			key: "youth_count",

			title: "Youth Rescued (19-25 age)",
			digit: data?.youth_count,
			icon: "price_check",
			variant: "lg blue",
		},
		{
			key: "total_adult_rescued",
			title: "Young Adult Rescued (25 & above age)",
			digit: data?.total_adult_rescued,
			icon: "settings_accessibility",
			variant: "lg green",
		},

		{
			key: "total_abused_families",

			title: "Total Abused Families",

			digit: data?.total_abused_families,
			icon: "settings_accessibility",
			variant: "lg blue",
		},
		{
			key: "total_families_rescued",
			noclick: true,
			title: "Average Family Size",
			digit:
				data?.total_families_rescued > 0
					? Math.round(
						data?.total_slaves / data?.total_families_rescued
					)
					: 0,
			icon: "price_check",
			variant: "lg blue",
		},
		{
			key: "total_slavery_years",
			title: "Total Years of Slavery",
			noclick: true,
			digit: data?.total_slavery_years,
			icon: "price_check",
			variant: "lg blue",
		},
		{//here key is not set yet
			key: "total_families_rescued",
			title: "Average Years of Slavery",
			noclick: true,
			digit:
				data?.total_families_rescued > 0
					? Math.round(
						data?.total_slavery_years /
						data?.total_families_rescued
					)
					: 0,
			icon: "price_check",
			variant: "lg blue",
		},
		{
			key: "total_followups",

			title: "Total Follow-ups",
			digit: data?.total_followups,
			icon: "emoji_flag",
			variant: "lg blue",
		},
		{
			key: "total_family_followups",
			title: "Families with Follow-Up Status",

			digit: data?.total_family_followups,
			percent: data?.total_family_followups / data?.total_families_rescued * 100,
			icon: "outlined_flag",
			variant: "lg blue",
		},
		{
			key: "total_not_followups",
			title: "Families Not Follow Up",
			percent: data?.total_not_followups / data?.total_families_rescued * 100,

			digit: data?.total_not_followups,
			icon: "do_not_disturb",
			variant: "lg blue",
		},
		{
			key: "total_baptized",
			title: "Total Number of Baptisms",

			digit: data?.total_baptized,
			icon: "water",
			variant: "lg blue",
		},
		{
			key: "school_going_children",
			title: "Children Attending School",
			percent: data?.school_going_children / data?.eligible_but_not_school_going * 100,

			digit: data?.school_going_children,
			icon: "directions_bus",
			variant: "lg blue",
		},
		{
			key: "eligible_but_not_school_going",
			title: "Eligible Children Not Attending School",
			percent: 100 - (
				(data?.total_school_trainings / data?.eligible_but_not_school_going) * 100
			),
			digit: data?.eligible_but_not_school_going,
			icon: "no_transfer",
			variant: "lg blue",
		},
		{
			key: "total_voc_trainings",
			title: "Vocational Training Admissions",
			digit: data?.total_voc_trainings,
			percent: data?.total_voc_trainings / data?.teenage_count * 100,
			icon: "model_training",
			variant: "lg blue",
		},
		{
			key: "total_school_trainings",
			title: "School Enrollments",
			percent: data?.total_school_trainings / data?.eligible_but_not_school_going * 100,

			digit: data?.total_school_trainings,
			icon: "school",
			variant: "lg blue",
		},
		{
			key: "total_business_granted",
			title: "Total Business Started and Launched",

			digit: data?.total_business_granted,
			icon: "business_center",
			variant: "lg blue",
		},
		// {
		// 	key: "total_families_rescued",
		// 	title: "Budget Expenditure",

		// 	digit: data?.total_budget_expenditure,
		// 	icon: "monetization_on",
		// 	variant: "lg blue",
		// },
		// {// here key is not set yet
		// 	noclick: true,
		// 	key: "Average-Debt-Per-Family",
		// 	title: "Average Debt Per Family",

		// 	digit: data?.total_loan_paid > 0
		// 		? Math.round(
		// 			data?.total_loan_paid / data?.total_families_rescued
		// 		)
		// 		: 0,
		// 	icon: "monetization_on",
		// 	variant: "lg blue",
		// },
	];
	return (
		<>
			{floats.map((data, index) => {
				return (
					<Col
						key={index}
						sm={6}
						lg={4}
					>
						<div

							onClick={data.noclick ? null : () => handleCardClick(data.key)}
							className={`mc-float-card ${data.variant}`}
							style={{
								background:
									"linear-gradient(to right, rgba(0,0,0,0.8), #077834)",
								cursor: data.noclick ? "default" : "pointer",
							}}
						>
							<h3>	<NumericFormat
								value={data.digit}
								displayType="text"
								thousandSeparator
								className="card-number"
							/>
								<span className="dollar">{data.percent ? Math.round(data.percent) + '%' : ''}</span></h3>
							<p>{data.title}</p>
							<i
								className="material-icons"
								style={{ color: "#077834" }}
							>
								{data.icon}
							</i>
						</div>
					</Col>
				);
			})}
		</>
	);
}
